export default __webpack_public_path__ + "static/media/filterIcon.c23ad7aa.svg";